export interface Notification {
    id: number;
    link: string;
    linkText: string;
    message: string;
    show: boolean;
    type: string;
    duration: number | null;
}

export interface NotificationState {
    notifications: Notification[];
}

const NotificationState: NotificationState = {
    notifications: [],
};

let nextNotificationId = 0;

export default {
    state: NotificationState,
    mutations: {
        SHOW_NOTIFICATION(state: NotificationState, notification: Notification) {
            state.notifications.push(notification);
        },
        HIDE_NOTIFICATION(state: NotificationState, id?: number) {
            if (id === undefined) {
                state.notifications = [];
            } else {
                state.notifications = state.notifications.filter((n) => n.id !== id);
            }
        },
    },
    actions: {
        hideNotification({ commit }: any, id?: number) {
            commit('HIDE_NOTIFICATION', id);
        },
        notify({ commit }: any, notification: any) {
            const id = nextNotificationId++;
            commit('SHOW_NOTIFICATION', {
                id,
                link: notification.link ?? '',
                linkText: notification.linkText ?? '',
                message: notification.message,
                show: true,
                type: notification.type ?? 'success',
                duration: notification.duration ?? 5000,
            });
            if (!notification.static) {
                setTimeout(() => {
                    commit('HIDE_NOTIFICATION', id);
                }, notification.duration ?? 5000);
            }
        },
    },
    getters: {
        getNotifications: (state: NotificationState) => {
            return state.notifications;
        },
    },
};
